import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../components/base/base.component';
import { VcsAPIService } from '../../services/vcs-api/vcs-api.service';
import { VcsService } from '../../services/vcs.service';
import { IFileItem } from '../../interface/file-item';
import { IchildFile } from '../../interface/child-file';
import { toUpper } from 'lodash-es';
import {ICommit} from "@wms/app/vcs/interface/commit";

@Component({
  selector: 'wms-view-changes-table',
  standalone: true,
  templateUrl: './wms-view-changes-table.component.html',
  styleUrls: ['./wms-view-changes-table.component.less'],
  imports: [CommonModule, FormsModule],
})

export class WmsViewChangesTableComponent extends BaseComponent implements OnInit, OnChanges {
  private vcsAPIService: VcsAPIService;
  private vcsService: VcsService;
  @Input() fileList: IFileItem[];
  @Input() selectedFileType: string;
  @Input() showCommitedFile: boolean;
  @Input() commitId: string
  @Input() commit?: ICommit;
  @Output() fileEmitter: EventEmitter<any> = new EventEmitter<any>();

  public allFileList: IFileItem[];
  public isAllFileChecked: boolean;

  ngOnInit(): void {
    this.allFileList = this.fileList;
  }

  constructor() {
    super();
    this.vcsAPIService = inject(VcsAPIService);
    this.vcsService = inject(VcsService);
  }

  ngOnChanges(): void {
    this.isAllFileChecked = false;
    this.allFileList = this.fileList;
    this.fileEmitter.emit('')
  }

  addOrRemoveFiles() {
    this.allFileList.map((file) => {
      file.isChecked = this.isAllFileChecked;
      if (file.files && file.files.length > 0) {
        file.files.map((childFile: IchildFile) => {
          childFile.isChecked = this.isAllFileChecked;
        });
      }
    });
    this.fileEmitter.emit(this.allFileList);
  }

  showDiff(file: any) {
    this.vcsService.changesType = this.selectedFileType
    this.vcsService.diffFileDetails = file
    this.vcsService.isViewingDiffFromCommitHistory =this.selectedFileType? !(this.vcsService.changesType === 'USER_CHANGES_SINCE_LAST_PULLED'||this.vcsService.changesType === 'USER_CHANGES_SINCE_LAST_PUSHED'):this.commitId ? true : false
    const fileDiffResp = this.commitId ? this.vcsAPIService.getFileDiffFromCommit(file.filepath, this.commitId) : this.vcsAPIService.getFileDifferences(file.filepath,this.selectedFileType);
    fileDiffResp.then((response): void => {
      this.vcsService.fileDiffResponse = response;
      this.vcsService.isTwoWayModalOpened = true
      this.vcsService.openDialogWithId('diffEditorModal');
    })
  }

  updateCheckList(selectedFile: IFileItem) {
    if (selectedFile.files) {
      selectedFile.files.forEach((file) => (file.isChecked = selectedFile.isChecked));
    }
    this.checkAllFileSelected()
    this.fileEmitter.emit(this.allFileList);
  }

  updateCheckListSub(selectedFile: IchildFile, file: IFileItem) {
    if (!selectedFile.isChecked) {
      file.isChecked = false;
    } else {
      if (file.files.every((child: IchildFile) => child.isChecked)) {
        file.isChecked = true;
      }
    }
    this.checkAllFileSelected()
    this.fileEmitter.emit(this.allFileList);
  }

  checkAllFileSelected() {
    let allFilesCount = 0;
    let selectedFiles = [];
    this.allFileList.forEach((fileItem) => {
      allFilesCount++;
      if (fileItem.isChecked) {
        selectedFiles.push(fileItem);
      }
      if (fileItem.files) {
        allFilesCount += fileItem.files.length;
        fileItem.files.forEach((file: IchildFile) => {
          if (file.isChecked) {
            selectedFiles.push(file);
          }
        })
      }
    });
    this.isAllFileChecked = allFilesCount === selectedFiles.length;
  }

  getFileIcon(file: any) {
    let fileIconsMap:any = {
            'FOLDER' : 'wms-folder',
            'SERVICE': 'wms-services',
            'FILE'   : 'wms-file',
            'PREFAB' : 'wms-prefab',
            'HTML'   : 'wms-file-html',
            'JS'     : 'wms-file-js',
            'CSS'    : 'wms-file-css',
            'JSON'   : 'wms-file-json',
            'JAR'    : 'wms-file-jar',
            'XML'    : 'wms-file-xml',
            'TXT'    : 'wms-file-txt',
            'PAGE'   : 'wms-page-template'
        },
        fileIcon;
    if (file.groupType) {
        return fileIconsMap[file.groupType];
    }
    fileIcon = fileIconsMap[toUpper(file.filepath.split('.').pop())];
    return fileIcon || 'wms-file';
};
}
